import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { useState } from 'react';
import { GET_CARRIERS } from 'Util/queries';
const { Option } = Select;

function CarriersDropDown({ onChange, form, ...rest }) {

    const [list, setList] = useState([])

    const { data } = useQuery(GET_CARRIERS, {
        variables: {
            where: {
                deleted_at: { _is_null: true }
            }
        },
        onCompleted() {
            setList(data.carriers)
        }
    });

    const handleChange = (value) => {
        const selected = list.find(item => item.id === value);
        if (form) {
            form.setFieldsValue({
                carrier_id: selected.id,
                carrier_name: selected.name,
                carrier_code: selected.code
            });
        }
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <div>
            <Select
                {...rest}
                placeholder="Select a carrier"
                onChange={handleChange}
            >
                {list.map(v => <Option value={v.id} key={`carriers-dd-opt${v.id}`}>{v.name}</Option>)}
            </Select>
        </div>
    )
}

export default CarriersDropDown
